module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-1@2x-08e40f3921d131269a5e2bd6cc390462.webp";